/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MasterContract,
  MasterContractInterface,
} from "../MasterContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract FadingHopeToken",
        name: "gameToken",
        type: "address",
      },
      {
        internalType: "contract KingdomNFT",
        name: "gameKingdoms",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "GlobalMessageEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "PinGlobalMessageEvent",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "targetTokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "AttackKingdom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "BurnKingdom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ClaimKingdomReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "MintNewUnit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "kingdomTokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
    ],
    name: "MintPlayerKingdom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "PinGlobalMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "SendGlobalMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_upgradeCost",
        type: "uint256[]",
      },
    ],
    name: "SetBuildingCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "incomePerSec",
        type: "uint256[]",
      },
    ],
    name: "SetTownCenterIncome",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
    ],
    name: "UpgradeKingdomBuilding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "ViewLastPinnedMessage",
    outputs: [
      {
        internalType: "string[]",
        name: "messages",
        type: "string[]",
      },
      {
        internalType: "uint256[]",
        name: "timestamps",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "blueprints",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "buildingCosts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "buildingLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timePassed",
        type: "uint256",
      },
    ],
    name: "calculateTownIncome",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
    ],
    name: "freeMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "string",
        name: "kingdomName",
        type: "string",
      },
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "freeMintWithURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "buildingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buildingLevel",
        type: "uint256",
      },
    ],
    name: "getBuildingCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "kingdoms",
    outputs: [
      {
        internalType: "contract KingdomNFT",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintKingdomPenalty",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintKingdomPenaltyMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pinMessages",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pinTimestamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract FadingHopeToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MasterContract__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    gameToken: string,
    gameKingdoms: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MasterContract> {
    return super.deploy(
      gameToken,
      gameKingdoms,
      overrides || {}
    ) as Promise<MasterContract>;
  }
  getDeployTransaction(
    gameToken: string,
    gameKingdoms: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(gameToken, gameKingdoms, overrides || {});
  }
  attach(address: string): MasterContract {
    return super.attach(address) as MasterContract;
  }
  connect(signer: Signer): MasterContract__factory {
    return super.connect(signer) as MasterContract__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MasterContractInterface {
    return new utils.Interface(_abi) as MasterContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MasterContract {
    return new Contract(address, _abi, signerOrProvider) as MasterContract;
  }
}
